module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./LYLogisticsView.js"));
	}, "LYLogisticsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LYLogisticsView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/LYLogistics/LYLogisticsView.js
// module id = 1037
// module chunks = 431